import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Row, Col, FloatingLabel } from "react-bootstrap";

const MachineFormModal = ({ show, onHide, onSave, products, initialData = null }) => {
    const [form, setForm] = useState({ name: "", productCapacities: [] });

    useEffect(() => {
        if (initialData) {
            setForm(initialData);
        } else {
            setForm({ name: "", productCapacities: [] });
        }
    }, [initialData]);

    const handleAddCapacity = () => {
        setForm(prev => ({
            ...prev,
            productCapacities: [...prev.productCapacities, { product: "", capacityPerHour: "", unit: "" }]
        }));
    };

    const handleChangeCapacity = (index, field, value) => {
        const updated = [...form.productCapacities];

        if (field === "product") {
            // Find selected product's unit code
            const selectedProduct = products.find(p => p._id === value);
            const unitCode = selectedProduct?.unitId?.unitCode || "";

            updated[index].product = value;
            updated[index].unit = unitCode; // auto-set unit
        } else {
            updated[index][field] = value;
        }

        setForm(prev => ({ ...prev, productCapacities: updated }));
    };

    const handleRemoveCapacity = index => {
        setForm(prev => ({
            ...prev,
            productCapacities: prev.productCapacities.filter((_, i) => i !== index)
        }));
    };

    const handleSubmit = () => {
        onSave(form);
    };

    return (
        <Modal show={show} onHide={onHide} size="lg" backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>{initialData ? "Edit" : "Add"} Machine </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <FloatingLabel label="Machine Name" className="mb-3">
                        <Form.Control
                            value={form.name}
                            onChange={e => setForm({ ...form, name: e.target.value })}
                            required
                        />
                    </FloatingLabel>

                    <div className="mb-2">
                        <strong>Product Capacities</strong>{" "}
                        <Button size="sm" variant="outline-primary" onClick={handleAddCapacity}>
                            + Add
                        </Button>
                    </div>

                    {form.productCapacities.map((cap, index) => (
                        <Row className="mb-2" key={index}>
                            <Col md={6} xl={5} className="mb-2">
                                <Form.Select
                                    value={cap.product}
                                    onChange={e => handleChangeCapacity(index, "product", e.target.value)}
                                >
                                    <option value="">Select Product</option>
                                    {products.map(p => (
                                        <option key={p._id} value={p._id}>{p.productName}</option>
                                    ))}
                                </Form.Select>
                            </Col>
                            <Col md={6} xl={5} className="mb-2">
                                <div className="d-flex gap-2">
                                    <div className="flex-grow-1">
                                        <div className="position-relative">
                                            <Form.Control
                                                placeholder="Capacity/hr"
                                                type="number"
                                                value={cap.capacityPerHour}
                                                onChange={e => handleChangeCapacity(index, "capacityPerHour", e.target.value)}
                                            />
                                            <span className="unit-suffix">{cap.unit}</span>
                                        </div>
                                    </div>
                                    <div className="align-content-center">
                                        <Button variant="outline-danger" size="sm" onClick={() => handleRemoveCapacity(index)}>Remove</Button>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    ))}
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>Cancel</Button>
                <Button variant="primary" onClick={handleSubmit}>
                    {initialData ? "Update" : "Save"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default MachineFormModal;
